import _asyncToGenerator from "/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import _objectSpread from "/project/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import { defineComponent, ref, computed, reactive, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApplyNewService } from '@/services/applyNew.service';
import { UserExamService } from '@/services/userExam.service';
import { LoginService } from '@/services/login.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { getToken, logger, copyToClipboard, AuthConf } from '@/utils';
import { upperFirst } from 'lodash-es';
import { PersonalComList, SchoolComList } from './fields/applyConf';
import EventBusItemDetail from '@/eventBus/itemDetail';

var components = require.context('./fields', true, /[a-zA-Z]\w+\.(vue)$/);

var comObj = {};
components.keys().forEach(function (fileName) {
  var _fileName$split, _fileName$split$pop;

  // 获取文件名
  var filename = fileName === null || fileName === void 0 ? void 0 : (_fileName$split = fileName.split('/')) === null || _fileName$split === void 0 ? void 0 : (_fileName$split$pop = _fileName$split.pop()) === null || _fileName$split$pop === void 0 ? void 0 : _fileName$split$pop.replace(/.\w+$/, '');

  if (filename) {
    // 获取组件配置
    var comp = components(fileName); // 若该组件是通过"export default"导出的，优先使用".default"，否则退回到使用模块的根

    var comName = 'Field'.concat(upperFirst(filename));
    comObj[comName] = comp.default || comp;
  }
});
export default defineComponent({
  components: _objectSpread({}, comObj),
  setup: function setup() {
    declareProviders([UserExamService]);
    var applyService = useService(ApplyNewService);
    var userExamService = useService(UserExamService);
    var loginService = useService(LoginService);
    var route = useRoute();
    var router = useRouter();
    var formRef = ref();
    var isLogin = ref(getToken());
    var loginInfo = reactive({
      visible: false,
      account: '',
      password: ''
    });
    var params = route.params;
    var itemId = +params.id;
    applyService.setItemId(itemId); // 编辑用户报名信息的时候，需要userExamId定位提交的报名信息

    var userExamId = route.query.userExamId;

    if (userExamId) {
      userExamService.setUserExamId(+userExamId);
      userExamService.getUserExamDetail().then(function () {
        var userExam = userExamService.userExam;

        if (userExam) {
          if (userExam.contestScheduleId) {
            applyService.formState.contestScheduleId = userExam.contestScheduleId; // 修改报名信息时先将 旧的报考组别ID存下来

            applyService.formState.oldContestScheduleId = userExam.contestScheduleId; // 修改报名信息，回显初始化出已选择的城市列表

            initAreaData();
          }

          return Object.assign(applyService.formState, userExam, {
            tempSchoolName: userExam.school,
            cardNo: applyService.formState.cardNo,
            area: userExam.areaIds || [],
            grade: userExam.grade || undefined
          });
        }
      });
    }

    var formState = computed(function () {
      return applyService.formState;
    }); // 监听登录状态 现实情况应该无法走到 当前页面未登录 而需要去登录的情况

    var getHistoryFlag = false;
    watch(function () {
      return AuthConf;
    }, function (newAuthConf) {
      // 仅考虑登录状态 有品牌报名情况 无品牌回显数据 是一种异常情况
      if (newAuthConf.login && !getHistoryFlag) {
        applyService.getApplyInfoFromHistory().then(function () {
          getHistoryFlag = true;
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    var phoneOnlyRead = computed(function () {
      // 登录状态 手机号只读
      if (isLogin.value) {
        return true;
      } else {
        var _applyService$item;

        return ((_applyService$item = applyService.item) === null || _applyService$item === void 0 ? void 0 : _applyService$item.accountGenerateType) !== 2;
      }
    });
    var judeShowSchoolInfo = computed(function () {
      if (applyService.ConfClassName.show || applyService.ConfGrade.show || applyService.ConfArea.show || applyService.ConfTempSchoolName.show || applyService.ConfTeacherName.show) {
        return true;
      }

      return false;
    });

    var onSubmit = function onSubmit() {
      formRef.value.validate().then(function () {
        var exParams = {};

        if (!phoneOnlyRead.value) {
          exParams = {
            verifyCode: applyService.formState.smsCode
          };
        }

        if (applyService.needAreaId) {
          exParams.areaId = applyService.formState.areaId;
        }

        return applyService.submit(userExamId, exParams).then(function (res) {
          if (res !== null && res !== void 0 && res.account && res !== null && res !== void 0 && res.password) {
            loginInfo.visible = true;
            loginInfo.account = res.account;
            loginInfo.password = res.password;
          } else {
            _message.success(userExamId ? '修改报名信息成功' : '报名成功');

            router.push({
              name: 'UserItemList'
            });
          }
        });
      }).catch(function (e) {
        logger.debug('提交报名表单失败 => ', e);
      });
    };

    var applyToLogin = function applyToLogin() {
      var actionLogin = function actionLogin() {
        loginService.showLoginDialog();
        nextTick(function () {
          EventBusItemDetail.emit('refill-login-info', {
            account: loginInfo.account,
            password: loginInfo.password
          });
        });
      };

      copyToClipboard("\u8D26\u53F7\uFF1A".concat(loginInfo.account, "\n      \u5BC6\u7801\uFF1A").concat(loginInfo.password)).then(function () {
        _message.success('已成功复制账号密码，请妥善保存以免丢失');

        actionLogin();
      }).catch(function () {
        actionLogin();
      });
    };

    var initAreaData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return applyService.onContestScheduleIdChange();

              case 2:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var areaIds, curretItem, _curretItem$children, curretSubItem;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          areaIds = userExamService.userExam.areaIds || [];
                          curretItem = applyService.areaList.find(function (item) {
                            return item.id === areaIds[0];
                          });

                          if (!curretItem) {
                            _context.next = 9;
                            break;
                          }

                          _context.next = 5;
                          return applyService.loadAreaData([curretItem]);

                        case 5:
                          curretSubItem = curretItem === null || curretItem === void 0 ? void 0 : (_curretItem$children = curretItem.children) === null || _curretItem$children === void 0 ? void 0 : _curretItem$children.find(function (item) {
                            return item.id === areaIds[1];
                          });

                          if (!curretSubItem) {
                            _context.next = 9;
                            break;
                          }

                          _context.next = 9;
                          return applyService.loadAreaData([curretSubItem]);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 1000);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function initAreaData() {
        return _ref.apply(this, arguments);
      };
    }(); // 获取


    applyService.getAllScheduleList();
    EventBusItemDetail.on('login-success', function () {
      isLogin.value = getToken();
      router.push({
        name: 'UserItemList'
      });
    });
    return {
      applyService: applyService,
      userExamService: userExamService,
      formState: formState,
      formRef: formRef,
      router: router,
      isLogin: isLogin,
      userExamId: userExamId,
      onSubmit: onSubmit,
      PersonalComList: PersonalComList,
      SchoolComList: SchoolComList,
      applyToLogin: applyToLogin,
      loginInfo: loginInfo,
      judeShowSchoolInfo: judeShowSchoolInfo
    };
  },
  provide: function provide() {
    return {
      formRef: this.formRef,
      isLogin: this.isLogin
    };
  }
});